export default __webpack_public_path__ + "media/mmbb-logo.dad52360.png";